import { LinearProgress, Stack } from "@mui/material";
import type { FC } from "react";
import { NotSet } from "../components/not-set";
import { TeamsWrapper } from "../components/teams-wrapper/teams-wrapper";
import { useBuiltTeamsMessage } from "../hooks/use-built-teams-message";

export const PreviewBodyTeamsContent: FC = () => {
  const { data, loading } = useBuiltTeamsMessage();

  if (loading) return <LinearProgress />;

  return (
    <Stack direction="column" spacing={4} sx={{ padding: 4 }}>
      {data ? <TeamsWrapper card={data} /> : <NotSet />}
    </Stack>
  );
};
